<template>
  <div class="detailContent">
    <!-- 慈善中国 >> 栏目名称（menuName） >> 列表 >> 本文 -->
    <Header></Header>
    <NavBar :navlist="navList"
            :activedNum="menuId"></NavBar>
    <div class="detail-item width1000">
      <div class="breadNav">
        <a class="text"
           href="/h5/index.html">慈善中国</a>
        <span>>></span>
        <a class="text"
           :href="'/h5/index.html?menuId='+(dataList?dataList.art.menuId:'')">{{dataList.menuName}}</a>
        <span>>></span>
        <a class="text"
           :href="'/h5/list.html?menuId='+(dataList?dataList.art.menuId:'')">列表</a>
        <span>>></span>
        <span class="
           navText
           ">文本</span>
      </div>
      <div class="title
           ">
        <h1>{{dataList?dataList.art.artTitle:''}}</h1>
      </div>
      <p class="times
           ">
        <span>{{time}} 来源：</span>
        <span>{{author}}</span>
      </p>
      <div class="twoList
           clearFix
           ">
        <div class="left_list
           ">
          <div class="wenz
           ">
            <!-- <p></p> -->
            <div class="wenz_detail"
                 v-html="dataList?dataList.art.artContent:''">
              <!-- {{dataList.art.artContent}} -->

            </div>

          </div>
          <!-- <div class="tj_read
           ">
            <h2>推荐阅读</h2>
            <div class="read_detail
           ">
              <div class="read_item
           clearFix
           ">
                <div class="img
           ">
                  <a href="
           "
                     target="_blank
           "><img src="http://culture.people.com.cn/NMediaFile/2020/0319/MAIN202003191024221892837268283.png
           "
                         width="215
           "
                         height="145
           "
                         border="0
           "
                         alt="战“疫”公益海报展示
           为积极配合做好统筹推进疫情防控和经济社会发展各项工作，坚决打赢疫情防控的人民战争、总体战、阻击战，文化和旅游部艺术司、人民网共同发起，联手多位知名设计师和十家美术学院，开展疫情防控相关主题海报设计公益活动，为战“疫”凝心聚力。
           【详细】
           "></a>
                </div>
                <div class="content
           ">
                  <h3 class="title
           ">战“疫”公益海报展示</h3>
                  <p class="text
           ">

                    为积极配合做好统筹推进疫情防控和经济社会发展各项工作，坚决打赢疫情防控的人民战争、总体战、阻击战，文化和旅游部艺术司、人民网共同发起，联手多位知名设计师和十家美术学院，开展疫情防控相关主题海报设计公益活动，为战“疫”凝心聚力。
                    <span class="red
           ">
                      <a target="_blank
           "
                         href="#
           ">【详细】</a>
                    </span>
                  </p>

                </div>
              </div>
              <div class="read_item
           clearFix
           ">
                <div class="img
           ">
                  <a href="
           "
                     target="_blank
           "><img src="http://culture.people.com.cn/NMediaFile/2020/0319/MAIN202003191016229629784306934.png
           "
                         width="215
           "
                         height="145
           "
                         border="0
           "
                         alt="战“疫”公益海报展示
           为积极配合做好统筹推进疫情防控和经济社会发展各项工作，坚决打赢疫情防控的人民战争、总体战、阻击战，文化和旅游部艺术司、人民网共同发起，联手多位知名设计师和十家美术学院，开展疫情防控相关主题海报设计公益活动，为战“疫”凝心聚力。
           【详细】
           "></a>
                </div>
                <div class="content
           ">
                  <h3 class="title
           ">人民战“疫”文艺作品征集</h3>
                  <p class="text
           ">
                    人民网文娱部发起人民战“疫”文艺作品征集，现向广大文艺工作者发出号召，鼓励文艺工作者用文学、美术、书法、摄影、曲艺、戏曲、短视频等形式，凝聚众志成城的强大正能量，为抗击疫情贡献自己的力量。
                    <span class="red
           ">
                      <a target="_blank
           "
                         href="#
           ">【详细】</a>
                    </span>
                  </p>

                </div>
              </div>
            </div>
          </div> -->
        </div>
        <div class="right_list
           ">
          <div class="hotPoint
           ">
            <h2>热点排行</h2>
            <div class="content
           ">
              <div class="list-item
           clearFix
           "
                   v-for="(item,index)
           in
           dataList?dataList.hotlist:
           ''
           "
                   :key="index
           ">
                <p class="order
           ">
                  <span :class="index<3?
           'red':
           ''
           ">{{index+1}}</span>
                </p>
                <p>
                  <a class="info
           "
                     :href="'/h5/detail.html?artId='+item.artId"
                     target="_blank
           ">{{item.artTitle}}</a>
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="footer
           ">
        <Footer></Footer>
      </div>
    </div>

  </div>
</template>

<script>
import Header from '@/components/index/header.vue';
import NavBar from '@/components/index/navBar.vue';
import Footer from '@/components/index/footer.vue';
import ajaxUtil from "@/assets/js/ajax.js";
import tools from "@/assets/js/utils.js";
import moment from 'moment';

export default {
  data () {
    return {
      artId: '',
      dataList: '',
      time: '',
      author: '',
      navList: '',
      menuId: '',
    }
  },
  components: {
    Header,
    NavBar,
    Footer
  },
  mounted () {
    this.artId = tools.getUrlPara('artId');
    this.getNavBar();
    this.init();
  },


  methods: {
    getNavBar () {
      var that = this;
      ajaxUtil.post('/api/web/menus/v1', {

      }).then(({ data }) => {

        that.navList = data;

      }).catch((err) => {

      });
    },
    init () {
      var that = this;
      ajaxUtil.post('/api/web/article/info/v1', {
        artId: that.artId
      }).then(({ data }) => {
        this.dataList = data;
        var time = moment(this.dataList.art.publishTime).format('YYYY年MM月DD日 hh:mm');
        this.time = time;
        this.author = data.art.author;
        this.menuId = data.art.menuId;

      }).catch((err) => {

      });
    }
  },
  watch: {
    dataList (val) {
      this.dataList = val;
    },
    menuId (val) {
      this.menuId = val
    }
  }

}
</script>

<style lang="less">
.detailContent {
  .footer {
    margin-top: 60px;
  }
  .detail-item {
    .breadNav {
      font: normal 12px/180% '宋体';
      height: 64px;
      line-height: 64px;
      .text,
      navText {
        margin: 0 6px;
      }
      .text:hover {
        color: #e60012;
        text-decoration: underline;
      }
    }
    .title h1 {
      font: bold 38px/150% 'Microsoft Yahei';
      margin-bottom: 5px;
    }
    .times {
      font-size: 14px;
      color: #666;
      line-height: 44px;
      padding-bottom: 10px;
      border-bottom: #d3d3d3 1px solid;
      span {
      }

      .link:hover {
        text-decoration: underline;
      }
    }
    .twoList {
      margin-top: 20px;
      .left_list {
        width: 66%;
        float: left;
        overflow: hidden;
        .wenz_detail {
          padding-right: 24px;
          padding-bottom: 20px;
          // border-bottom: 1px solid #d3d3d3;
          img {
            // width: 100%;
          }
          p {
            color: #222;
            font: normal 18px/200% 'Microsoft Yahei';
            // margin: 25px 0;
          }
        }
        .tj_read {
          margin-top: 20px;
          h2 {
            font: normal 24px/200% 'Microsoft Yahei';
          }
          .read_detail {
            .read_item {
              height: 145px;
              overflow: hidden;
              // border-bottom: 1px solid #d3d3d3;
              margin-top: 40px;
              .img {
                float: left;
                margin-right: 10px;
              }
              .content {
                // margin-top: 10px;
                .title {
                  font-size: 22px;
                  font-weight: 800;
                }
                .text {
                  margin-top: 14px;
                  font: normal 14px/200% 'Microsoft Yahei';
                }
                .red,
                .red a:link,
                .red a:visited,
                .red a:hover {
                  color: #e60012;
                }
              }
            }
          }
        }
      }
      .right_list {
        width: 30%;
        float: right;
        .hotPoint {
          font: normal 16px/53px 'Microsoft Yahei';
          border: #efefef 1px solid;
          margin-top: 24px;
          padding: 0 10px;

          h2 {
            border-bottom: #efefef 1px solid;
          }
          .content {
            padding: 10px 0;
            .list-item {
              font-size: 14px;
              color: #0f0f0f;

              .order {
                width: 14%;
                height: 40px;
                line-height: 40px;
                float: left;
                span {
                  width: 26px;
                  height: 26px;
                  display: inline-block;
                  background: #999;
                  text-align: center;
                  line-height: 26px;
                  color: #fff;
                  border-radius: 4px;
                }
                .red {
                  background: #e60012;
                }
              }
              .info {
                width: 86%;
                height: 40px;
                float: right;
                line-height: 40px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              .info:hover {
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
  }
}
</style>
